import type { CapacityValues } from '../../types/components/filter_bar_types';

export const getCapacityText = ({
  minGuests,
  maxGuests,
  allowSeated,
  allowStanding,
}: CapacityValues) => {
  const guestRangeText = getGuestRangeText(minGuests, maxGuests);
  const eventStyleText = getEventStyleText(allowSeated, allowStanding);
  return `${eventStyleText}, ${guestRangeText}`;
};

export const getGuestRangeText = (minGuests?: number, maxGuests?: number) => {
  if (!minGuests && !maxGuests) {
    return 'Any number';
  }
  if (minGuests === maxGuests) {
    return `${minGuests} guests`;
  }
  if (maxGuests && !minGuests) {
    return `${maxGuests} guests`;
  }
  if (!maxGuests && minGuests) {
    return `${minGuests} guests`;
  }
  return `${minGuests} - ${maxGuests} guests`;
};

export const getEventStyleText = (
  allowSeated: boolean,
  allowStanding: boolean,
) => {
  if (allowSeated && allowStanding) {
    return 'Seated or Standing';
  }

  if (allowSeated) {
    return 'Seated';
  }
  if (allowStanding) {
    return 'Standing';
  }

  return 'Seated or Standing';
};
